const state = {
    playing: false
};

const getters = {};

const actions = {
    setStatus: function(context, status) {
        context.commit("setPlaying", status);
    }
};

const mutations = {
    setPlaying: function(state, status) {
        state.playing = status;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
